<template>
  <div class="fccPublicacoes">
    <div :class="divWidthChange" class="conteudoWidth" :key="keyLocalDeProva">
      <fccTitlePage :titlePage="titlePage" v-if="permissaoPage"></fccTitlePage>
      <b-tabs>
        <b-tab title="Configuração" active>
          <fccAbaConfiguracao />
        </b-tab>

        <b-tab title="Local de Prova" :disabled="isDisabledTabs[1]">
          <fccAbaLocalDeProva v-if="!!statusAtual && !isDisabledTabs[1]" />
        </b-tab>
        <b-tab title="Opção" :disabled="isDisabledTabs[2]">
          <fccAbaOpcao v-if="!!statusAtual && !isDisabledTabs[2]" />
        </b-tab>
        <b-tab title="Classificação" :disabled="isDisabledTabs[3]">
          <fccAbaClassificacao v-if="!!statusAtual && !isDisabledTabs[3]" />
        </b-tab>
        <b-tab title="Solicitação Especial" :disabled="isDisabledTabs[4]">
          <fccAbaSolicitacaoEspecial v-if="!!statusAtual && !isDisabledTabs[4]" />
        </b-tab>
        <b-tab title="Vagas Reservadas" :disabled="isDisabledTabs[5]">
          <fccAbaVagasReservadas v-if="!!statusAtual && !isDisabledTabs[5]" />
        </b-tab>
        <b-tab title="Mensagem" :disabled="isDisabledTabs[6]"
          ><FccAbaMensagem v-if="!!statusAtual && !isDisabledTabs[6]"
        /></b-tab>
        <b-tab title="Envio de E-mail e SMS" :disabled="isDisabledTabs[7]"></b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import fccAbaConfiguracao from './fccAbaConfiguracao/fccAbaConfiguracao.vue'
import fccAbaLocalDeProva from './fccAbaLocalDeProva/fccAbaLocalDeProva.vue'
import fccAbaClassificacao from './fccAbaClassificacao/fccAbaClassificacao.vue'
import fccAbaSolicitacaoEspecial from './fccAbaSolicitacaoEspecial/fccAbaSolicitacaoEspecial.vue'
import fccAbaVagasReservadas from './fccAbaVagasReservadas/fccAbaVagasReservadas.vue'
import fccAbaOpcao from './fccAbaOpcao/fccAbaOpcao.vue'
import FccAbaMensagem from './FccAbaMensagem/fccAbaMensagem.vue'
import store from '../../../store'
import { TP_ETAPA } from './constantes'

export default {
  components: {
    fccAbaConfiguracao,
    fccAbaLocalDeProva,
    fccAbaOpcao,
    fccAbaClassificacao,
    fccAbaSolicitacaoEspecial,
    fccAbaVagasReservadas,
    FccAbaMensagem
  },
  data() {
    return {
      titlePage: 'Local de Prova'
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    listaStatus() {
      return store.state.localDeProva.listaStatus
    },
    statusAtual() {
      return store.state.localDeProva.statusAtual
    },
    isDisabledTabs() {
      const array = Array.from(Array(Object.keys(TP_ETAPA).length).keys())

      return array.map(
        (index) =>
          !this.configuracao ||
          !this.listaStatus?.find((item) => item.tpEtapa === index)?.tpSituacao
      )
    },
    keyLocalDeProva() {
      return this.configuracao?.idlocalconfig ?? 0
    }
  }
}
</script>